<script setup lang="ts">
import {computed, defineProps, ref, defineEmits, onMounted, watch} from 'vue';
import Room from "@/models/Room";
import {useStore} from "vuex";
const emit = defineEmits(['dataPaginate'])
const props = defineProps({
  itemPerpPage:{type:Number, default:10},
})
const store = useStore()
const page = ref(1);
const totalPage = ref(1);
const dataToPaginate = ref<Room[]>(store.getters['room_data/getRoomFoundData'])
const  setPagination = () =>{
  totalPage.value = Math.ceil(dataToPaginate.value.length / props.itemPerpPage)
  return computed(() =>
      dataToPaginate.value.slice((page.value - 1) * props.itemPerpPage, page.value * props.itemPerpPage)
  );
}
// const setRoomData = ()=>{
//   return computed(()=>store.getters['room_data/getRoomFoundData'])
// }
onMounted(()=>{
  store.dispatch('room_data/loadInitialData')
  emit('dataPaginate', {data:setPagination()??[]})
})
watch(() => store.state.room_data.roomAvailableData, (newValue) => {
  dataToPaginate.value = newValue;
  emit('dataPaginate', {data:setPagination()})
});
const nextPage = () => {
  if (page.value !== Math.ceil(dataToPaginate.value.length / props.itemPerpPage)) {
    page.value += 1;
    emit('dataPaginate', {data:setPagination()})
  }
};
const backPage = () => {
  if (page.value !== 1) {
    page.value -= 1;
    emit('dataPaginate', {data:setPagination()})
  }
};

const goToPage = (numPage:number) => {
  page.value = numPage;
 emit('dataPaginate', {data:setPagination()})

};

</script>

<template>
  <ul class="uk-pagination uk-flex-center impx-pagination uk-margin-remove-top" data-uk-margin="">
    <li class="uk-first-column" @click="backPage"><a ><span data-uk-pagination-previous="" class="uk-pagination-previous uk-icon"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" data-svg="pagination-previous"><polyline fill="none" stroke="#000" stroke-width="1.2" points="6 1 1 6 6 11"></polyline></svg></span></a></li>
    <li :class="p==page?'uk-active':''" v-for="p in totalPage" :key="p" @click="goToPage(p)"><span>{{p}}</span></li>
    <li @click="nextPage"><a ><span data-uk-pagination-next="" class="uk-pagination-next uk-icon"><svg width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" data-svg="pagination-next"><polyline fill="none" stroke="#000" stroke-width="1.2" points="1 1 6 6 1 11"></polyline></svg></span></a></li>
  </ul>
</template>

<style scoped>

</style>